module.exports = __webpack_public_path__ + "static/media/client_site_view_blue.36f011b0.svg";